import { combineReducers } from "redux";
import { routerReducer as router } from "react-router-redux";
import Auth from 'containers/Auth';
import toasterReducer from '../components/Toaster/toasterReducer';


export const makeRootReducer = asyncReducers => (state, action) => {
  return combineReducers({
    router,
    Auth,
    toaster: toasterReducer,
    ...asyncReducers
  })(state, action);
};

export const injectReducer = (store, { key, reducer }) => {
  store.asyncReducers[key] = reducer;
  store.replaceReducer(makeRootReducer(store.asyncReducers));
};

export default makeRootReducer;



// WEBPACK FOOTER //
// ./src/store/reducers.js